import type { PartialDeep } from 'type-fest';
import type { FeatureToggles } from '../../../src/store/facade/facadeApiV3';

export const generateFeatureTogglesMock = (): PartialDeep<FeatureToggles> => ({
    searchOptions: true,
    vehicleOptions: true,
    vehicleOutdoorTemperature: false,
    routeOptions: true,
    chargingOptions: true,
    newRoutingFeature: true,
    deviceId: true,
    stationOpenTime: true,
});
